<template>
  <div>
    <alert-error :error="error"></alert-error>

    <v-toolbar>
      <v-toolbar-title>{{ $t('PERSONAL_INTERESTS.ITEMS') }} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="dialogCreate = !dialogCreate">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.ADD') }} {{ $t('PERSONAL_INTERESTS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="pa-4">
      <item-list
        v-if="tags"
        :tags="tags"
        :languages="languages"
        @refresh-items="refreshItems"
      />

      <v-dialog
        v-if="dialogCreate"
        v-model="dialogCreate"
        persistent
        max-width="400px"
      >
        <item-create-page
          :languages="languages"
          @cancel="dialogCreate = !dialogCreate"
          @success="createdItem"
        ></item-create-page>
      </v-dialog>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'TagsPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ItemList: () => import('@/modules/tags/components/TagList.vue'),
    ItemCreatePage: () => import('@/modules/tags/pages/TagCreatePage.vue')
  },

  data: () => ({
    tags: null,
    dialogCreate: false,
    error: null,

    languages: []
  }),

  created() {
    this.$store
      .dispatch('localization/retrieveLanguages')
      .then(response => {
        this.languages = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });
    this.refreshItems();
  },

  methods: {
    createdItem() {
      this.refreshItems();
      this.dialogCreate = !this.dialogCreate;
    },

    refreshItems() {
      this.$store
        .dispatch('tag/retrieveTagsTranslations')
        .then(({ data }) => {
          data.forEach(item => {
            // cleaning of unused data
            delete item.slug;
            delete item.created_at;
            delete item.updated_at;

            item.translations.forEach(translation => {
              this.languages.forEach(language => {
                if (translation.language_id == language.id) {
                  item[language.locale] = translation.name;
                  item[language.locale + '_id'] = translation.id;
                }
              });
            });
          });
          this.tags = data;
        })
        .catch(error => {
          this.error = error.response;
        });
    }
  }
};
</script>
